__turbopack_context__.v({
  "venti-widget": "VentiWidget-module-scss-module__3xJHEq__venti-widget",
});
